import React from 'react';
import style from '../css/footer.module.css';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <>
      <div id={style.fot_warp}>
        <div>
          <ul >
            <li style={{display:"flex",gap:"20px"}}>
              <Link to="/ServiceTerms">
                서비스 이용약관
              </Link>
              <Link to="/PrivacyTerms">
                개인정보 처리방침
              </Link>
              <Link to="/LocationTerms">
                위치기반서비스 이용약관
              </Link>
            </li>
          </ul>
          주식회사 로컬 / 고객센터 1800-1321 / (03925)서울특별시 마포구 월드컵북로 396 누리꿈스퀘어연구개발타워 1005호 <span className="br_pc" />
          Copyright@2024 CATCH. Registration Administrators All Rights Reserved.
        </div>
      </div>
    </>

  );
}

export default Footer;
